<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<ng-template #content let-c="close" let-d="dismiss">
                    <div class="modal-header" >
                        <h4 style=" font-size: 25px; margin: 0px;" class="modal-title" id="modal-basic-title">Esri products support</h4>
                        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
                    </div>
                    <div class="modal-body" style="padding-left: 30px;
    padding-right: 30px;">
                        <p>Starting June 1, 2023, Technical Support for Esri products will be moved​ to the <a target="_blank" href="https://www.esri.com/en-us/my-esri-login">My Esri portal</a>. My Esri offers a range of services and options, including creating and accessing technical support cases. We strongly recommend that you make the switch to <a target="_blank" href="https://www.esri.com/en-us/my-esri-login">My Esri</a> as soon as possible in order to ensure that you have the best possible experience when requesting support.</p>
                        <p>If you have any questions or issues, feel free to <a style="color:#7366ff !important;cursor:pointer" (click)="OpenSupportRequest()">click here</a> to contact us</p>
                    </div>
                    <div class="modal-footer" >
                        <a   class="btn btn-outline-dark customhover" href="https://www.esri.com/en-us/my-esri-login" target="_blank">Switch to My Esri</a>
                    </div>
                </ng-template>
<div *ngIf="!accessdenied" class="row">
    

    <div *ngIf="showEsriProductSelector" class="col-xl-6" style="    margin-top: 30px;">
        <a href="https://www.esri.com/en-us/my-esri-login" target="_blank" >
            <div class="card height-equal">
                <div class="card-header" style="min-height:200px;border-radius: 15px;padding:60px">
                    <h5 style="text-transform: inherit !important;">Esri Products</h5><span style="padding-top: 15px;">The fastest way to request a support case for Esri's ArcGIS products.</span>
                </div>
            </div>
        </a>
        
    </div>
    <div *ngIf="showEsriProductSelector" class="col-xl-6" style="    margin-top: 30px;">
         <a (click)="showSupportContent(true)" style="cursor:pointer;" target="_blank">
             <div class="card height-equal">
                <div class="card-header" style="min-height:200px;border-radius: 15px;padding:60px">
                    <h5 style="text-transform: inherit !important;">gistec and third-party products​</h5><span style="padding-top: 15px;">Get help with third-party and custom products.</span>
                </div>
            </div>
         </a>
        
    </div>
      

    <div *ngIf="!showEsriProductSelector" class="col-xl-8 no-padding">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Operating system information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="form-group col-md-23 col-sm-23 col-xs-23  no-padding" style="margin-bottom:20px; ">
                <div class="form-floating">
                    <select (change)="osVendorChanged($event)" class="form-select" id="osVendorSelect" aria-label="Floating label select example">
                        <option *ngFor="let vendorI of vendorInformation" [value]="vendorI.Vendor">
                            {{ vendorI.Vendor }}
                        </option>
                    </select>
                    <label for="floatingSelect">Operating system name</label>
                </div>
            </div>
            <div class="form-group col-md-23 col-sm-23 col-xs-23  no-padding" style="margin-bottom: 20px; " *ngIf="operatingSystem">
                <div class="form-floating">
                    <select class="form-select" id="osSelect" aria-label="Floating label select example">
                        <option *ngFor="let osI of OSInformation">
                            {{ osI.os}}
                        </option>
                    </select>
                    <label for="floatingSelect">Operating system version</label>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Product information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; ">
                <div class="form-floating">
                    <select (change)="SelectProductVendor($event)" class="form-select" id="productVendorSelect" aria-label="Floating label select example">
                        <option *ngFor="let product of productInformation" [selected]="product.Selected"  [value]="product.Vendor">
                            {{ product.Vendor }}
                        </option>
                    </select>
                    <label for="floatingSelect">Vendor</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; " *ngIf="category">
                <div class="form-floating">
                    <select (change)="selectProductMainCategory($event)" class="form-select" id="productMainCategorySelect" aria-label="Floating label select example">
                        <option *ngFor="let pmc of productMainCategories" [value]="pmc.MainCategoryName">
                            {{ pmc.MainCategoryName}}
                        </option>
                    </select>
                    <label for="floatingSelect">Category</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px;  " *ngIf="subcategory">
                <div class="form-floating">
                    <select (change)="selectProductSubCategory($event)" class="form-select" id="productSubCategorySelect" aria-label="Floating label select example">
                        <option *ngFor="let psc of productSubCategories" [value]="psc.SubCategoryName">
                            {{ psc.SubCategoryName}}
                        </option>
                    </select>
                    <label for="floatingSelect">Sub category</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom: 20px; " *ngIf="product">
                <div class="form-floating">
                    <select class="form-select" id="productSelect" aria-label="Floating label select example">
                        <option *ngFor="let prod of products" [value]="prod">
                            {{ prod }}
                        </option>
                    </select>
                    <label for="floatingSelect">Product</label>
                </div>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <input [(ngModel)]="Case.CaseObject.Product_Version__c" type="text" class="form-control" id="floatingInputValueSubject">
                    <label for="floatingInputValueSubject">Product version</label>
                </div>
            </div>

        </div>

        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top: 20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Case information</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">

            <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <input [(ngModel)]="Case.CaseObject.Subject" type="text" class="form-control" id="floatingInputValueSubject">
                    <label for="floatingInputValueSubject">Subject</label>
                </div>
            </div>
            
            <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">
                <div class="form-floating">
                    <textarea [(ngModel)]="Case.CaseObject.Description" style="height:150px" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>
                    <label for="floatingTextareaDescription">Description</label>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top:20px">
                <div class="form-group">
                    <div clas="col-md-3" style="padding-top:15px ">
                        <div class="form-row">
                            <input type="file" (change)="filesSelect($event)" name="file" id="file" class="inputfile" />
                            <label for="file">ADD Attachment <i class="far fa-file"></i></label>
                        </div>
                    </div>
                    <table class="table" *ngIf="files.length > 0">
                        <thead>
                            <tr>
                                <th width="50%">Name</th>
                                <!--<th>Size</th>-->
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of files;let i = index">
                                <td><strong>{{ item.name }}</strong></td>
                                <!--<td  nowrap>{{ item.size/1024/1024|number:2 }} MB</td>-->
                                <td nowrap>
                                    <a style="cursor:pointer" (click)="removeFile(i)">
                                        <span class="fa fa-trash"></span> Remove
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="" style="margin-top: 20px;margin-bottom:20px">
                <div style="text-align: right" class="col-md-12 col-sm-12 col-xs-12">
                    <button ng-disabled="btnSubmitDisabled" class="btn mygistec-main-btn" (click)="submitCase()">{{btnSubmitText}}</button>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="!isError && !showEsriProductSelector" class="col-xl-4" style="padding-right: 0px; padding-left: 30px;">
        <div class="row" style="margin-bottom:15px !important">
            <!--Request details-->
                <a (click)="showSupportContent(false)"  style=" margin-bottom:15px;   width: 100%;
                                font-size: 13px;
                                height: 35px;
                                margin-right: 20px;
                                font-weight: inherit;
                                color: rgb(0, 166, 182);
                                background-color: white;
                                border-color: rgb(0, 166, 182);" class="btn btn-default">
                                    Back
                </a>
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Request Details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div class="row small-section-content">
                    <div class="col-xl-12 no-padding">
                        <div style="font-weight: bold;">Support type</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{supportTypeName}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:10px">
                        <div style="font-weight: bold;font-size: 17px;">Requester name</div>
                        <div style="margin-top:10px">
                            <img [src]="authentication.userData.contactLogo" style="width: 30px;height:30px; border-radius: 50%;" />
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd; padding-left: 10px;">{{authentication.userData.firstName}} {{authentication.userData.lastName}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Requester account</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{authentication.userData.portalAccount.name}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;font-size: 17px;">Request Origin</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">Web</p>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>
